<template>
	<div>
		<div class="relative">
			<div
				v-if="isLabelShow"
				class="club-member-input-label"
			>
				{{ context.attributes['label-text'] }}
				<div
					v-b-tooltip.hover
					class="club-member-info ml-2"
					title="Школа управления СКОЛКОВО предлагает дополнительные привилегии для членов определенных сообществ и клубов"
				>
					<i class="icon-info icon-icon_info" />
				</div>
			</div>
			<div
				:class="`formulate-input-element formulate-input-element--${context.class}`"
				:data-type="context.type"
			>
				<div class="custom-club-member--input">
					<multiselect
						v-model="model"
						tag-placeholder="Выбрать (свое название)"
						placeholder="Выберите значение"
						select-label="Выбрать"
						selected-label="Выбрано"
						deselect-label="Убрать"
						label="name"
						track-by="id"
						:options="clubsList"
						:multiple="true"
						:searchable="true"
						:taggable="true"
						@tag="addTag"
						@select="updateModelClub"
						@remove="updateModelClub"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
	components: { Multiselect },
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			model: [],
			clubsList: [
				{
					id: 1,
					name: 'Gynto',
				},
				{
					id: 2,
					name: 'Клуб первых',
				},
				{
					id: 3,
					name: 'Noôdome',
				},
				{
					id: 4,
					name: 'CEO Remap Club',
				},
				{
					id: 5,
					name: 'А-клуб',
				},
				{
					id: 6,
					name: 'Сбер Private Banking',
				},
				{
					id: 7,
					name: 'Private Banking ВТБ',
				},
			],
		};
	},
	computed: {
		isLabelShow() {
			if (this.context.attributes.is_label_hide) return false;
			return true;
		},
	},
	created() {
		if (this.context.model) {
			this.model = this.context.model.split(', ').map((el) => {
				const element = this.clubsList.find((club) => club.name === el);
				const tag = element || {
					name: el,
					id: this.clubsList[this.clubsList.length - 1].id + 1,
				};
				if (!element) this.clubsList.push(tag);
				return tag;
			});
		}
	},
	methods: {
		addTag(newTag) {
			const tag = {
				name: newTag,
				id: this.clubsList[this.clubsList.length - 1].id + 1,
			};
			this.clubsList.push(tag);
			this.model.push(tag);
			this.updateModelClub();
		},
		updateModelClub() {
			this.context.model = this.model.map((el) => el.name).join(', ');
		},
	},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";
.formulate-input[data-type=CustomClubMember] input {
	border: none !important;
}

.custom-club-member--input {
	.multiselect__tags {
		border: none !important;
		border-radius: 0 !important;
		border-bottom: 1px solid #949ABA !important;
		font-size: 1rem;
		padding: 0.5rem 1rem 0.5rem 0rem !important;
		line-height: 1.2 !important;
		height: auto;
		font-family: "Raleway", sans-serif;
		font-weight: 500;
	}

	.multiselect__option--selected,
	.multiselect__option--selected:after,
	.multiselect__option--selected.multiselect__option--highlight:after {
		background: $theme-lightblue !important;
		color: black;
	}
	.multiselect__tag,
	.multiselect__option--highlight,
	.multiselect__option--highlight:after,
	.multiselect__option--selected.multiselect__option--highlight:after	{
		background: $blue !important;
		color: white;
	}

	.multiselect__tag-icon {
		display: flex;
		align-items: center;
		justify-content: space-around;

		&::after {
			color: $border-color;
		}
	}

	.multiselect__tag-icon:hover {
		background: transparent !important;

		&::after {
			color: white;
		}
	}

	.multiselect__placeholder {
		margin-bottom: 0;
	}

	.multiselect__tag {
		margin-bottom: 0;
	}

	.multiselect__placeholder {
		color: $border-color!important;
		font-weight: 300;
	}
}
</style>
<style lang="scss" scoped>
.club-member-input-label {
    display: flex;
    align-items: center;
	margin-bottom: 0.5rem;
}

.club-member-info {
	cursor: pointer;
	width: 1.1rem;
    height: 1.1rem;
    font-size: 0.6rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
	padding: 0.2rem;
	background-color: #ACB5C7;
	color: white;

	.icon-icon_info {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 2px;
	}
}
</style>
